import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--edit-payment-method-modal'
    ];

    openModal(event) {
        event.preventDefault();
        this.profileEditPaymentMethodModalOutlet.openModal();
    }
}
